import React from 'react';
import './NewTaxiPage.css';
import WhyUs from '../../components/WhyUs/WhyUs';
import CallBarNewTaxi from './CallBarNewTaxi';
import AutoScallingyad2taxiforsale from "../../components/AutoScallingyad2taxiforsale/AutoScallingyad2taxiforsale";
import { FaHandPointer } from "react-icons/fa";
import NewTaxisHomePageCards from "../../components/NewTaxisHomePageCards/NewTaxisHomePageCards";
import ContactInsuranceForm from '../InsuranceTaxiPage/ContactInsuranceForm';
import InsuranceSummaryHomepage from '../../components/InsuranceSummaryHomepage/InsuranceSummaryHomepage';
import { Helmet } from 'react-helmet';
import Rav4 from './Rav4.png';
import Corolla from './Corolla.png';
import E220 from './e220.png';
import Sonata from './Sonata.png';
import Camery from './Camery.png';
import Elantra from './Elantra.png';
import YarisCross from './YarisCross.png';
import BZ4X from './BZ4X.png';
import Sportage from './Sportage.png';
import Niro from './Niro.png';
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";

const taxis = [
  {
    name: 'טויוטה ראב 4 אימושן',
    image: Rav4,
    description: 'רכב פנאי מרווח עם טכנולוגיה היברידית, נוחות מקסימלית לנהג מונית, צריכת דלק חסכונית במיוחד וביצועים מעולים בעיר ובכביש המהיר.',
  },
  {
    name: 'טויוטה קורולה',
    image: Corolla,
    description: 'המונית הקלאסית של ישראל – חסכונית, אמינה, נוחה לנסיעות ארוכות. תחזוקה זולה, נוחות מושב גבוהה ואמינות מוכחת לשנים.',
  },
  {
    name: 'מרצדס E220',
    image: E220,
    description: 'רכב פרימיום לנהגי VIP – עיצוב יוקרתי, מערכות בטיחות מתקדמות, חוויית נהיגה חלקה, מושלם לשירותי מוניות אקסקלוסיביים.',
  },
  {
    name: 'יונדאי סונטה',
    image: Sonata,
    description: 'היברידית מתקדמת עם תא נוסעים נוח, מושבים מרווחים, עיצוב מודרני וטכנולוגיה עכשווית. אידאלית לנהגים שעובדים הרבה שעות על ההגה.',
  },
  {
    name: 'טויוטה קאמרי',
    image: Camery,
    description: 'חווית נהיגה חלקה ואלגנטית, אמינות ללא תחרות, ביצועים מצוינים, צריכת דלק מעולה למונית היברידית עם נוכחות.',
  },
  {
    name: 'יונדאי אלנטרה',
    image: Elantra,
    description: 'רכב קומפקטי מושלם לעיר – חיסכון מקסימלי, נוחות לנהיגה יומיומית, אידיאלי לנהגים פרטיים ומוניות ספיישל.',
  },
  {
    name: 'טויוטה יאריס קרוס',
    image: YarisCross,
    description: 'קרוסאובר היברידי קטן, מתאים במיוחד למוניות עירוניות – חסכון, נוחות וסטייל ייחודי. פופולרי מאוד בתקופה האחרונה.',
  },
  {
    name: 'טויוטה BZ4X',
    image: BZ4X,
    description: '100% חשמלי! ללא דלק, ללא תחזוקה שוטפת, שקט לגמרי – העתיד של המוניות כבר כאן. טווח נסיעה מרשים וטעינה מהירה.',
  },
  {
    name: 'קיה ספורטאז׳',
    image: Sportage,
    description: 'ג׳יפון מרווח, נוח ונעים, עם עיצוב צעיר ומנוע חזק. מתאים למוניות משפחתיות או מוניות בין-עירוניות.',
  },
  {
    name: 'קיה נירו (חשמלית)',
    image: Niro,
    description: 'רכב חשמלי מתקדם עם טווח ארוך, תא נוסעים מרווח, שקט מוחלט בנסיעה וצריכה אפסית. מושלם לשוק המוניות החדש.',
  },
];


const NewTaxiPage = () => {
  return (
    <>
    <Helmet>
  {/* Title & Description */}
  <title>מוניות חדשות למכירה | BuyTaxi - כל הדגמים, כל הפתרונות במקום אחד| קנה טקסי</title>
  <meta
    name="description"
    content="מחפש מונית חדשה למכירה? אצלנו תמצא את הדגמים המובילים בישראל - טויוטה, יונדאי, מרצדס, קיה ועוד. טרייד אין, מימון מלא, וזכויות ציבוריות - הכל במקום אחד!"
  />

  {/* Open Graph Meta Tags */}
  <meta property="og:title" content="מוניות חדשות למכירה | BuyTaxi - כל הדגמים במקום אחד" />
  <meta
    property="og:description"
    content="קניית מונית חדשה עם מימון מלא, זכויות ציבוריות, אפשרות לטרייד אין על מונית ישנה. ראב4, קאמרי, אלנטרה, סונטה, BZ4X ועוד - הכנס עכשיו."
  />
  <meta property="og:image" content="https://buytaxi.co.il/og-image.jpg" />
  <meta property="og:url" content="https://buytaxi.co.il/NewTaxiPage" />
  <meta property="og:type" content="website" />

  {/* Twitter Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="BuyTaxi | מוניות חדשות למכירה עם מימון מלא וטרייד אין" />
  <meta name="twitter:description" content="מצא את המונית החדשה המושלמת - זכויות ציבוריות, ביטוח למונית, דגמים מובילים ושירות אישי." />
  <meta name="twitter:image" content="https://buytaxi.co.il/og-image.jpg" />
  <meta name="twitter:site" content="@buytaxi" />

  {/* Keywords - מפוצץ! */}
  <meta
    name="keywords"
    content="מוניות חדשות, מונית חדשה למכירה, קניית מונית חדשה, ראב4 מונית, קאמרי מונית, סונטה מונית, אלנטרה מונית, מוניות היברידיות, מוניות חשמליות, זכויות ציבוריות למכירה, מימון למונית, מימון מונית חדשה, טרייד אין מונית, ליסינג מונית, דגמי מוניות בישראל, מונית VIP, רכב למונית, קניית רכב למונית, מוניות 2025, מונית לעסק, עבודה כנהג מונית, מונית חדשה מחיר, רכישת מונית חדשה, רכב חדש למונית, תחנות מוניות, קבלן מוניות, מוניות חדשות להשכרה, שוק המוניות, BuyTaxi, קנה טקסי"
  />

  {/* Canonical URL */}
  <link rel="canonical" href="https://buytaxi.co.il/NewTaxiPage" />
</Helmet>
    <div className="NewTaxiPageContiner">
      <div className="NewTaxiPageContent">
        <h2 className="NewTaxiPageH2">הקטלוג הכי חם למוניות חדשות בישראל במחירים הכי משתלמים</h2>
        
<div className="NewTaxiPage-catalog">
  {taxis.map((taxi, index) => (
<a key={index} href="tel:+972502268395" className="NewTaxiPage-phoneLink">
  <div className="NewTaxiPage-card">
    <div className="NewTaxiPage-imageWrapper">
      <img src={taxi.image} alt={taxi.name} />
      <p className="NewTaxiPage-imageNote">*התמונה להמחשה בלבד</p>
    </div>
    <div className="NewTaxiPage-text">
      <h2 className="NewTaxiPageh2">{taxi.name}</h2>
      <p className="NewTaxiPage-description">{taxi.description}</p>
    </div>
  </div>
</a>

  ))}
</div>
<div className="InsurancePageContactSection">
  <h2 className='InsuranceTaxiContactPageTitle'>השאר פרטים ונציג יחזור אלייך בהקדם</h2>
  <ContactInsuranceForm />
</div>

        <div className='NewTaxiPageWhyus'>
          <WhyUs />
        </div>
                <h1 className="NewTaxiPage-MainTitle">למה כדאי לקנות מונית חדשה דווקא עכשיו?</h1>

        <p className="NewTaxiPage-Intro">
          אם אתה נהג מונית או שוקל להיכנס לתחום, אין זמן טוב יותר מלהשקיע במונית חדשה. בעידן של חדשנות, שירות, ומקצועיות, רכישת <strong>מונית חדשה</strong> יכולה לשדרג אותך באופן מיידי. בכתבה הבאה נפרט את כל הסיבות למה <strong>מוניות חדשות</strong> הן הבחירה החכמה ביותר, נענה על שאלות נפוצות, ונצלול לעומק של מונחים חשובים כמו <strong>טרייד אין למונית</strong>, <strong>מימון למונית חדשה</strong>, <strong>זכות ציבורית</strong> ועוד.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">היתרונות בקניית מונית חדשה</h2>

        <ul className="NewTaxiPage-AdvantagesList">
          <li>אמינות גבוהה ותקלות כמעט אפסיות</li>
          <li>תצרוכת דלק נמוכה יותר וחיסכון חודשי</li>
          <li>אחריות יצרן מלאה – שקט נפשי ל-3 עד 7 שנים</li>
          <li>נוחות לנהג ולנוסעים</li>
          <li>טכנולוגיות חדשות: חיישני רוורס, מערכות בטיחות מתקדמות ועוד</li>
        </ul>

        <h2 className="NewTaxiPage-SectionTitle">מונית חדשה VS מונית יד שנייה</h2>
        <p className="NewTaxiPage-Paragraph">
          כשמשווים בין <strong>מונית חדשה</strong> לבין מונית מיד שנייה, רואים הבדל עצום באיכות החיים של הנהג. מונית חדשה נותנת ביטחון, שירות טוב יותר ללקוח, חיסכון בזמן בטיפולים, ובסופו של דבר – גם יותר הכנסות.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">טרייד אין למונית – שדרג את הקיים</h2>
        <p className="NewTaxiPage-Paragraph">
          יש לך מונית ישנה? אל תתעכב – תוכל לעשות <strong>טרייד אין</strong> בקלות, להחליף את הרכב הישן ולקבל <strong>מונית חדשה</strong> עם אחריות מלאה. עסקת הטרייד אין מאפשרת לך להמשיך לעבוד בלי הפסקות מיותרות.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">אפשרויות מימון למונית חדשה</h2>
        <p className="NewTaxiPage-Paragraph">
          כיום ניתן לרכוש <strong>מונית חדשה</strong> עם מימון מלא, עד 100%, בתנאים משתלמים במיוחד. חברות רבות מציעות תוכניות מימון גמישות – בין אם אתה עצמאי או שכיר.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">מהי זכות ציבורית ולמה היא חשובה?</h2>
        <p className="NewTaxiPage-Paragraph">
          <strong>זכות ציבורית</strong> היא האישורים שאתה צריך כדי להפעיל מונית חוקית. ניתן לרכוש או לשכור זכות ציבורית – לפי הצרכים שלך. לעיתים ישנן חבילות הכוללות גם <strong>מונית חדשה</strong> וגם <strong>זכות ציבורית</strong> במחיר אחד.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">שאלות נפוצות על מוניות חדשות</h2>
        <div className="NewTaxiPage-FAQ">
          <h3 className="NewTaxiPage-Question">כמה עולה מונית חדשה?</h3>
          <p className="NewTaxiPage-Answer">המחיר תלוי בדגם, בזכות הציבורית, ובתנאי המימון. ניתן למצוא <strong>מוניות חדשות</strong> במחירים תחרותיים במיוחד.</p>

          <h3 className="NewTaxiPage-Question">האם כדאי לקנות או לשכור מונית?</h3>
          <p className="NewTaxiPage-Answer">אם אתה מתחיל או לא בטוח, אפשרות <strong>השכרה</strong> יכולה להתאים. אם אתה רוצה יציבות והכנסה לטווח הארוך – רכישה עדיפה.</p>

          <h3 className="NewTaxiPage-Question">כמה עולה זכות ציבורית?</h3>
          <p className="NewTaxiPage-Answer">המחירים משתנים לפי הביקוש. ניתן למצוא זכויות למכירה או להשכרה גם בפריסה לתשלומים.</p>

          <h3 className="NewTaxiPage-Question">איך מתבצעת העברת בעלות למונית?</h3>
          <p className="NewTaxiPage-Answer">העברה מתבצעת דרך משרד הרישוי, בליווי של אנשי מקצוע. לרוב, אם רכשת <strong>מונית חדשה</strong> דרך סוכנות, הם ידאגו לכל הבירוקרטיה בשבילך.</p>
        </div>

        <h2 className="NewTaxiPage-SectionTitle">למה דווקא עכשיו?</h2>
        <p className="NewTaxiPage-Paragraph">
          שוק התחבורה משתנה במהירות. הרגולציה הופכת מחמירה יותר, ודגמים חדשים נכנסים עם פתרונות מתקדמים וירוקים. אם אתה רוצה להקדים את כולם – זה הזמן להשקיע ב<strong>מונית חדשה</strong>.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">מחפש מונית להשכרה או למכירה?</h2>
        <p className="NewTaxiPage-Paragraph">
          באתר שלנו תמצא מגוון רחב של <strong>מוניות חדשות</strong> להשכרה או למכירה, כולל אפשרות ל<strong>טרייד אין</strong>, <strong>מימון</strong>, ו<strong>העברת בעלות</strong>. כל הפתרונות תחת קורת גג אחת.
        </p>

        <h2 className="NewTaxiPage-SectionTitle">לסיכום – הדרך שלך להתחיל נכון</h2>
        <p className="NewTaxiPage-Conclusion">
          בין אם אתה נהג ותיק ובין אם אתה שוקל להיכנס לענף, <strong>מונית חדשה</strong> היא הצעד הנכון. אל תוותר על הזדמנות להתחיל חזק, בטוח, ורווחי.
        </p>
        <p className="NewTaxiPage-AIInfo">
  *מאמר זה נכתב ונערך באמצעות מערכת בינה מלאכותית (AI) מתקדמת, תוך הקפדה על דיוק מירבי והתאמה מלאה לתחום מוניות חדשות בישראל. המידע המוצג מבוסס על ניתוחים עדכניים בשוק, מילות מפתח מובילות וניסיון נצבר של עשרות אלפי נהגים.*
</p>
  <div className="AutoScallingyad2taxiforsaleh4">
      <h2>מגוון מוניות יד 2 מחכות רק לך!</h2>
    </div>
  <div className="AutoScallingIconsHomepage">
      <AutoScallingyad2taxiforsale />
    </div>
    <div className="swipe-hint mobile-only">
  <FaHandPointer className="swipe-icon" />
  <span className="swipe-text">דפדף ימינה</span>
</div>
<div className="NewTaxisHomePageCardsAtPageDiv2">
  <NewTaxisHomePageCards />
  <button className="hero-button-InsurancePage" onClick={() => window.location.href = '/AllTaxiYad2ForSalepage'}>למאגר המוניות</button>
</div>
<div className="InsuranceSummaryNewTaxipage">
  <InsuranceSummaryHomepage />
</div>
      </div>
      
      <CallBarNewTaxi />
    </div>
    <div className="ArticlesPreviewNewTaxiPage">
  <ArticlesPreview />
</div>
    </>
  );
};


export default NewTaxiPage;
